import { render, staticRenderFns } from "./DistributionWayPickerDialog.vue?vue&type=template&id=fb7eb5be&scoped=true"
import script from "./DistributionWayPickerDialog.vue?vue&type=script&lang=ts"
export * from "./DistributionWayPickerDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb7eb5be",
  null
  
)

export default component.exports